import { UploadSyncResource } from "@gx/ts-contracts/services/uploader/resources/uploader_pb";

import type {
  CreateSourceState,
  FileUploadProgress,
} from "@/pages/sources/components/create/sources/types";

export enum CreateSourceFileUploadPhase {
  IDLE = "IDLE",
  CREATING_SOURCE = "CREATING_SOURCE",
  UPLOADING = "UPLOADING",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export enum CreateSourceFileUploadOperation {
  CREATE_SOURCE = "CREATE_SOURCE",
  UPLOAD_FILES = "UPLOAD_FILES",
}

export type CreateSourceFileUploadState = CreateSourceState & {
  files: File[];
  phase: CreateSourceFileUploadPhase;
  session: UploadSyncResource | null;
  fileProgressMap: Map<string, FileUploadProgress>;
  overallProgress: number;
  isUploading: boolean;
};
